import React, { useState, useEffect } from 'react';
import { API } from '../lib/ortam';
import { authBaslik } from '../lib/authBaslik';

// TEK RENDER (F3, 2026-10-29, kullanıcı kararı): panel figürü = basım PNG'si. Sunucu figürü tek soruluk ÖSYM
// kitapçığında derleyip basılı PDF'ten kırpar (/api/tikz/onizleme); burada basılı boyutunda gösterilir
// (1 pt = 96/72 px). Çizgi, punto ve yazı tipi kitapçıktakiyle aynıdır.
const PX_PT = 96 / 72;

export default function BasimFigur({ tikz, gorsel, olcek = 1, yedek = null }) {
  const [sonuc, setSonuc] = useState(null);
  const [hata, setHata] = useState(null);

  useEffect(() => {
    if (!tikz && !gorsel) return undefined;
    let iptal = false;
    setSonuc(null); setHata(null);
    fetch(`${API}/api/tikz/onizleme`, {
      method: 'POST', headers: authBaslik(),
      body: JSON.stringify(tikz ? { tikz, olcek } : { gorsel, olcek }),
    })
      .then((r) => r.json())
      .then((d) => { if (!iptal) { d.basarili ? setSonuc(d) : setHata(d.hata || 'Önizleme başarısız'); } })
      .catch((e) => { if (!iptal) setHata(e.message); });
    return () => { iptal = true; };
  }, [tikz, gorsel, olcek]);

  if (hata) {
    return yedek || <div className="text-orange-600 p-3">Diyagram derlenemedi: {hata}</div>;
  }
  if (!sonuc) return <div className="text-center py-6 text-gray-500 font-serif">Diyagram derleniyor...</div>;
  return <BasimFigurResim sonuc={sonuc} />;
}

// Basım PNG'sini basılı genişliğinde gösterir. Müşteri paneli de kullanır (F3b md. 3; PNG oradaki uçtan gelir).
export function BasimFigurResim({ sonuc, alt = 'Soru görseli' }) {
  const [x0, , x1] = sonuc.kutu_pt;
  return (
    <div className="text-center py-2 overflow-auto max-w-full">
      <img src={`data:image/png;base64,${sonuc.png_base64}`} alt={alt} data-basim-figur="1"
        className="inline-block max-w-full h-auto" style={{ width: `${((x1 - x0) * PX_PT).toFixed(1)}px` }} />
    </div>
  );
}
